/**
 * Axios Instances
 *
 * Two pre-configured axios instances for the dual-backend architecture:
 * - erebusHttp: Go API (cookie-based auth via HttpOnly session cookie)
 * - legacyHttp: Java API (in-memory Bearer token managed by legacy-token-manager)
 *
 * Instances are created at module level with no baseURL. Call init() to set
 * base URLs from @erebus/runtime-config before making any requests.
 */

import axios from 'axios'

/**
 * Axios instance for the Erebus Go API.
 *
 * Authenticated via HttpOnly session cookie — withCredentials is enabled so
 * the browser sends the cookie automatically. No Authorization header is set.
 */
export const erebusHttp = axios.create({
  withCredentials: true
})

/**
 * Axios instance for the legacy Java API.
 *
 * Authenticated via in-memory Bearer token attached by the legacy token
 * manager's request interceptor. Does NOT use cookies.
 */
export const legacyHttp = axios.create()
